export default {
    scorePerSign: 50,
    bonusExchangeConstant: 3,
};
